import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import { registerUser } from "features/user/userActions";
import { setNotification } from "features/Notification/notificationSlice";
import { resetState } from "features/user/userSlice";

const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function UserForm({ selectedIndex, setSelectedIndex }) {
  const dispatch = useDispatch();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [showPass, setShowPass] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const { error, success, userInfo } = useSelector((state) => state.user);

  const onSubmit = async (userForm) => {
    document.querySelectorAll(".needs-validation").forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });
    setLoading(true);
    dispatch(registerUser(userForm))
      .then((res) => {
        if (res.type === "auth/register/rejected") {
          dispatch(
            setNotification({
              message: res.payload,
              type: "error",
            })
          );
          setLoading(false);
        }
        if (res.type === "auth/register/fulfilled") {
          setSelectedIndex((prev) => 1);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        dispatch(
          setNotification({
            message: err.message,
            type: "error",
          })
        );
      });
  };

  useEffect(() => {
    document.querySelectorAll(".needs-validation").forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });

    if (success) {
      setLoading(false);
    }
  }, [success]);

  // useEffect(() => {
  //   if (userInfo) {
  //     setSelectedIndex(selectedIndex + 1);
  //   }
  // }, [userInfo]);

  useEffect(() => {
    if (error) {
      dispatch(resetState());

      dispatch(
        setNotification({
          message: error,
          type: "error",
        })
      );
      setLoading(false);
    }
  }, [error]);

  return (
    <form
      id="accountForm"
      method="post"
      className={`form-horizontal needs-validation ${
        Object.keys(errors).length > 0 ? "was-validated" : ""
      }`}
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <div className="row">
        <div className="col-lg-2">
          <label htmlFor="firstName">First Name</label>
        </div>

        <div className="col-lg-5">
          <div className="mb-3">
            <input
              id="firstName"
              className="form-control"
              placeholder="First Name"
              {...register("firstName")}
              required
            />
            <div className="invalid-feedback">Please enter first name.</div>
          </div>
        </div>

        <div className="col-lg-5">
          <div className="mb-3">
            <input
              className="form-control"
              placeholder="Last Name"
              {...register("lastName")}
              required
            />
            <div className="invalid-feedback">Please enter last name.</div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-2">
          <label htmlFor="phone">Phone</label>
        </div>

        <div className="col-lg-7">
          <div className="mb-3">
            <input
              id="tel"
              className="form-control"
              placeholder="(xxx) xxx-xxxx"
              {...register("phone")}
              required
            />
            <div className="invalid-feedback">Please enter phone number.</div>
          </div>
        </div>

        <div className="col-lg-3">
          <div className="mb-3">
            <input
              className="form-control"
              placeholder="Extension"
              {...register("phoneExt")}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-2">
          <label htmlFor="email">Email</label>
        </div>

        <div className="col-lg-10">
          <div className="mb-3">
            <input
              id="email"
              type="email"
              className="form-control"
              placeholder="example@website.com"
              {...register("email", {
                pattern: {
                  value: emailRegex,
                  message: "Entered value does not match email format",
                },
              })}
              required
            />
            {errors.email && (
              <div className="invalid-feedback">{errors.email?.message}</div>
            )}
            {/* <div className='invalid-feedback'>Please enter a valid email address.</div> */}
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-2">
          <label htmlFor="password">Password</label>
        </div>

        <div className="col-lg-10">
          <div className="mb-3 input-group input-group-merge">
            <input
              id="password"
              type={showPass ? "text" : "password"}
              className="form-control"
              placeholder="Minimum 6 characters"
              {...register("password", { minLength: 6, maxLength: 20 })}
              required
            />
            <div
              className="input-group-text"
              data-password="false"
              onClick={() => setShowPass(!showPass)}
            >
              <span className="password-eye"></span>
            </div>
            <div className="invalid-feedback">
              Please enter a valid email address.
            </div>
          </div>
        </div>
      </div>

      <div className="mb-3">
        <div className="form-check d-inline-block">
          <input
            type="checkbox"
            className="form-check-input"
            id="customCheck4"
            required
          />
          <label className="form-check-label" htmlFor="customCheck4">
            I have read and accept the Terms Of Service and Privacy Policy.
          </label>
        </div>
      </div>

      <ul className="list-inline wizard mb-0">
        <li className="next list-inline-item float-end">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {!isLoading ? (
              <>
                Next <i className="mdi mdi-arrow-right ms-1"></i>
              </>
            ) : (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Creating User...
              </>
            )}
          </button>
        </li>
      </ul>
    </form>
  );
}

export default UserForm;
